











import { Component, Mixins, Prop } from "vue-property-decorator";
import { ITicket } from "@/models/tickets";
import Context from "@/mixins/context";
import { ClientRoutes } from "@/data/enums/router";

@Component
export default class UTicketLink extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public ticketId!: ITicket["id"];

  @Prop({ required: false, default: undefined })
  public clientId?: ITicket["client_id"];

  @Prop({
    default: "router-link",
    validator: value =>
      ["a", "router-link", "u-link", "b-button"].includes(value)
  })
  public tag?: string;

  // Computed

  public get disabled() {
    const { $attrs } = this;
    return "disabled" in $attrs && ($attrs.disabled as unknown) !== false;
  }

  public get ticketRoute() {
    // Mock Client
    if (this.isMockClientContext)
      return {
        name: `admin__upmindTicket`,
        params: {
          ticketId: this.ticketId
        }
      };
    // Client
    if (!this.isAdmin)
      return {
        name: ClientRoutes.SUPPORT_TICKET,
        params: {
          ticketId: this.ticketId
        }
      };
    // Admin (Client Context)
    else if (this.clientId)
      return {
        name: `adminClientSupportTicket`,
        params: {
          clientId: this.clientId,
          ticketId: this.ticketId
        }
      };
    // Admin
    else
      return {
        name: `adminSupportTicket`,
        params: {
          ticketId: this.ticketId
        }
      };
  }

  public get ticketLink() {
    switch (this.tag) {
      case "u-link":
        return {
          tag: this.tag,
          props: {
            ...this.$attrs,
            disabled: this.disabled
          }
        };
      case "b-button":
        return {
          tag: this.tag,
          props: {
            ...this.$attrs,
            tag: "router-link",
            disabled: this.disabled
          }
        };
      case "a":
      case "router-link":
      default:
        return {
          tag: "router-link"
        };
    }
  }
}
